import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  signal,
} from "@angular/core";

@Component({
  selector: "pane-card",
  templateUrl: "./pane-card.component.html",
  styleUrl: "./pane-card.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaneCardComponent implements AfterContentInit {
  @ContentChild("cardTop")
  private topContent: ElementRef;

  @ContentChild("cardBottom")
  private bottomContent: ElementRef;

  public hasTopContent = signal(false);
  public hasBottomContent = signal(false);

  ngAfterContentInit() {
    this.updateContentPresence();
  }

  private updateContentPresence(): void {
    this.hasTopContent.set(Boolean(this.topContent));
    this.hasBottomContent.set(Boolean(this.bottomContent));
  }
}
